import React, {Suspense, lazy,useEffect} from 'react'
import {BrowserRouter, Route, Switch} from 'react-router-dom'

const Home = lazy(() => import('./Home'));

function Pages() {
  useEffect(() => {
    const isTaoTeng = window.location.hostname.endsWith('szsttkj.com')
    const isIppzone = window.location.hostname.endsWith('ippzone.com')
    const isIppzoneNet = window.location.hostname.endsWith('ippzone.net')
    if (isTaoTeng || isIppzoneNet) {
      document.title = "腾淘科技";
    }else if (isIppzone) {
      document.title = "深圳市腾淘科技有限公司";
    }
  },[])
  return (
    <BrowserRouter>
      <Suspense fallback={null}>
        <Switch>
          <Route component={Home}/>
        </Switch>
      </Suspense>
    </BrowserRouter>
  );
}

export default Pages
